const errorPrefix = 'errors.formFields.rangeLength';

const rangeLength = (min, max, fieldName) => (value) => {
  let errorKey;
  
  if (value.trim().length < min) errorKey = 'min';
  if (value.trim().length > max) errorKey = 'max';
  
  if (!errorKey) return undefined;
  
  errorKey = fieldName ? `${errorPrefix}.${errorKey}.${fieldName}` : `${errorPrefix}.${errorKey}`;
  
  return [errorKey, min, max];
};

export default rangeLength;
